
















import { Vue, Component } from 'vue-property-decorator';
import { isRgAdmin } from '@/api/rg';

@Component
export default class KnowledgeSummary extends Vue {
    activeName: string = '';
    hasPermission: boolean = false;
    loading: boolean = true;

    mounted() {
        this.initPermission();
    }

    created() {
        this.getActiveTab();
    }

    /**
     * 初始化权限
     */
    private async initPermission() {
        try {
            this.loading = true;
            const res = await isRgAdmin(this.rgId);
            console.log(res);
            if (res.code === 200 && res.data?.role === 'RGADMIN') {
                this.hasPermission = true;
            } else {
                this.hasPermission = false;
            }
        } catch (_) {
            this.hasPermission = false;
        } finally {
            this.loading = false;
        }
    }

    /**
     * 获取当前活跃的Tab
     * 根据路由名称确定当前Tab
     */
    getActiveTab() {
        const routeName = this.$route.name;
        this.activeName = routeName || 'rg_knowledge_prepare';
    }

    /**
     * 处理Tab切换
     * 更新路由，触发子页面切换
     */
    handleChangeTab() {
        console.log('this.activeName', this.activeName);
        this.$router
            .push({
                name: this.activeName,
                query: {
                    rgId: `${this.rgId}`
                }
            })
            .catch(e => e);
    }

    /**
     * 获取RG ID
     */
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
